// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3KaX2","cell":"ColumnAccessor_cell__1nRgz","firstCellAccent":"ColumnAccessor_firstCellAccent__2COqY"};